// This file contains all the js imports to get "legacy" js working. Legacy JS
// refers to JS that was written with sprockets as the asset pipeline library.
// Set properties on `window` so they are globally available outside of js that
// is compiled as part of the asset bundle.
import "./window_setup"
import '../../node_modules/bootstrap/dist/js/bootstrap.min.js';

import './application/javascripts/anchor-link';


/**
 * The items sectioned below should be code split and loaded dynamically in the future
 */

import './application/javascripts/newsletter_feed'; // TODO Move to /newsletter page

/**
 * The items sectioned above should be code split and loaded dynamically in the future
 */

import './styles/application.scss';

// The `render` function is similar to `timeago` which is a library that used to
// be vendor'd in via sprockets. The interface is slighty different as it
// expects either a single node or a nodeList. A query that results in an empty
// set will break.
window.timeago = (nodeList) => {
  nodeList.length > 0 && render(nodeList);
};
